export default "__VITE_ASSET__CM6D4dtR__"